function setQueryStringParameter(name, value) {
	const params = new URLSearchParams(location.search);
	params.set(name, value);
	window.history.replaceState({}, "", decodeURIComponent(`${location.pathname}?${params}`));
}

/*
Simple Accessible Tab control v6.1.1 19-03-2017
Author: Mike Foskett
Incept: 09-03-2016
Article: http://websemantics.uk/articles/accessible-tab-navigation/
Furtherence of: Heydon Pickering - http://heydonworks.com/practical_aria_examples/#tab-interface

  Uses ARIA attributes (via CSS) to control what's visible.

  Requires (tested):
	addEventListener (IE8+)
	preventDefault (IE9+)
	classList (IE10+)
	querySelectorAll (IE9+)

  Required parameter:
	none

  Optional parameters:

	tabListClass : "tl_list" (default)

	onClass : "ON" (default)
			Customisable, set default tab on.
			Used for initialisation only.

	hoverableClass : "tl-hoverable" (default)
			Customisable, allow mouse-hover to switch tabs.
			Apply to the navigation ul.

  Version 6.1.1 - 19-03-2017 - Added: up/down arrow keys; nested tablists
  Version 6.1 - 16-08-2016
  Version 6 - 10-07-2016
  Version 5.2 - 17-03-2016
  Version 5 - 09-03-2016
  Version 4 - 27-01-2012
  Version 3 - 25-01-2012
  Version 1 - 27-05-2010
*/


var accessibleTabs6 = (function () {

	"use strict";

	var d = document;
	var tabListClass;
	var squareListClass;
	var toggleListClass;
	var onClass;
	var hoverableClass;
	var slm = $(".squarelist-container");
	var sha = $(".squareHasCta");
	var nextButton = slm.find(".squarelist-next");
	var prevButton = slm.find(".squarelist-prev");
	var sliderWidth = $(".slider-barlist").outerWidth();
	var perSlideScroll = sliderWidth / sha.length;
	var current = 1;
	var flag = false;
	var isSquareList = $('div').hasClass('squarelist-container');
	var isToggleList = $('div').hasClass('togglelist-container');
	let squareTextCount;
	
	var setTabsOff = function (tabList) {
		var i = tabList.tabs.length;
		while (i--) {
			setTab(tabList.tabs[i], false);
		}
	};

	var setTab = function (tab, switchOn) {
		if (tab && tab.SquareTabID && flag && isSquareList) {
			current = tab.SquareTabID;

			let currentSquareList = "li.squareHasCta#" + (tab.SquareTabID);
			let nextSlide = "li.slider-bar" + (tab.SquareTabID);
			let slideMargin = ((tab.SquareTabID - 1) * perSlideScroll) + "px";

			moveSlide(slideMargin, perSlideScroll, nextSlide);
			tabCount(current);
			goToSquare(Number(current));
		}

		if (tab && tab.SquareTabID && isToggleList && flag) {
			let currentToggleList = "li#" + tab.SquareTabID + ".toggleHasCta a.tab div.toggle-header";
			
			$("li.toggleHasCta a.tab div.toggle-header" +".active").removeClass("active");
			$(currentToggleList).addClass("active");
		}

		if (tab && tab.panelId) {
			if ((isToggleList || isSquareList) && !flag) {
				changeContent(1);
			} else {
				d.getElementById(tab.panelId).setAttribute("aria-hidden", !switchOn);
			}
			
			tab.setAttribute("aria-selected", switchOn);
			tab.setAttribute("tabindex", switchOn ? "0" : "-1");

			$("[data-tabid]").hide();
			$(`[data-tabid='${tab.panelId}']`).show();

			if (location.search.length > 0 && location.search.includes('tabname') && switchOn && window.matchMedia("(min-width: 1200px)").matches) {

				let params = new URLSearchParams(location.search),
					tabname = params.get("tabname").replaceAll(" ", "+");

				if (document.querySelector('.tablist-container li a.tab[href="#' + tabname + '"]')) {
					$("html, body").animate({
						scrollTop: $(".tablist-container").offset().top - 30
					}, 400);
				}

			}
		}
	};

	var _activateTab = function (e) {
		var tab = e.target;
		
		if (e.preventDefault) {
			e.preventDefault();
			setTabsOff(tab.tabList);
			setTab(tab, true);
			//d.getElementById(tab.panelId).children[0].focus();
			var h = e.target.getAttribute("href").replace("#", "");
			setQueryStringParameter("tabname", h);
		}
	};

	var _keypressed = function (e) {

		var tab = e.target;
		var newNo = -1;
		var tabs = tab.tabList.tabs;
		var maxNo = tabs.length - 1;

		if (e.keyCode === 37 || e.keyCode === 38) { // left / up arrow
			newNo = (tab.no === 0) ? maxNo : tab.no - 1;
		}
		if (e.keyCode === 39 || e.keyCode === 40) { // right arrow / down arrow
			newNo = (tab.no === maxNo) ? 0 : tab.no + 1;
		}

		if (newNo > -1) {
			setTabsOff(tab.tabList);
			setTab(tabs[newNo], true);
			tabs[newNo].focus();
		}
	};

	var _tabHovered = function (e) {

		var a = e.target;
		var useHover = a.tabList.classList.contains(hoverableClass);
		if (useHover) {
			_activateTab(e);
		}
	};

	var _events = function (tab) {
		tab.addEventListener("click", _activateTab, false);
		tab.addEventListener("keydown", _keypressed, false);
		tab.addEventListener("mouseover", _tabHovered, false);
	};

	var _initialiseAriaAttributes = function (tab) {
		var tabPanel = d.getElementById(tab.panelId);

		tab.parentNode.setAttribute("role", "presentation");
		tab.setAttribute("role", "tab");
		tab.setAttribute("aria-controls", tab.panelId);
		tab.setAttribute("SquareTabID", tab.SquareTabID);

		tabPanel.setAttribute("role", "tabpanel");
		tabPanel.setAttribute("aria-labelledby", tab.id);

		// Make first <section> object keyboard focussable
		// Preferably a heading
		// Tabindex=0 to work both forwards and backwards through the keychain
		try {
			tabPanel.children[0].setAttribute("tabindex", "0");
		} catch (e) {
			console.log("Could not focus on the first child element: ", e.message);
		}

	};

	var _setUpConfig = function (cfg) {
		toggleListClass = cfg.toggleListClass || "tl_list";
		squareListClass = cfg.squareListClass || "tl_list";
		tabListClass = cfg.tabListClass || "tl_list";
		onClass = cfg.onClass || "ON";
		hoverableClass = cfg.hoverableClass || "tl-hoverable";
	};

	var _setUpTab = function (tab, panelId, SquareTabID, count) {
		tab.no = count;
		tab.id = "tab-" + panelId;
		tab.panelId = panelId;
		tab.SquareTabID = SquareTabID;
		_initialiseAriaAttributes(tab);
		_events(tab);
	};


	var _initialiseTabList = function (tabList, listType, ctatype) {

		var defaultTab = 0;
		var panelId;
		var SquareTabID;
		var tabPanel;
		var i;
		
		if (tabList) {
			tabList.setAttribute("role", listType);
			tabList.tabs = tabList.getElementsByClassName("tab");
			tabList.list = tabList.getElementsByClassName(ctatype);

			i = tabList.tabs.length;
			
			while (i--) {

				tabList.tabs[i].tabList = tabList;
				panelId = tabList.tabs[i].href.slice(tabList.tabs[i].href.lastIndexOf("#") + 1);
				if (isSquareList || isToggleList) {
					SquareTabID = tabList.list[i].id;
				}

				tabPanel = d.getElementById(panelId);

				if (tabPanel) {
					_setUpTab(tabList.tabs[i], panelId, SquareTabID, i);
					if (tabList.tabs[i].classList.contains(onClass)) {
						defaultTab = i;

						// onClass only used to declare intial state, so remove from DOM
						tabList.tabs[i].classList.remove(onClass);
						d.getElementById(panelId).classList.remove(onClass);
					}
				}
			}
			setTabsOff(tabList);
			if (tabList.tabs[defaultTab] && tabList.tabs[defaultTab].panelId) {
				setTab(tabList.tabs[defaultTab], true);
			}
		}
	};

	var _isMustardCut = function (e) {
		// check browser feature support (IE10+)
		return (
			(typeof d.querySelectorAll === "function") &&
			d.addEventListener &&
			!!d.documentElement.classList // IE10+
		);
	};

	var init = function (cfg) {
		var listType;
		var tabLists;
		var i;
		var ctaType;
		
		if (_isMustardCut()) {
			_setUpConfig(cfg);
			if (isToggleList) {
				tabLists = d.getElementsByClassName(toggleListClass);
				listType = "togglelist";
				ctaType = "toggleHasCta"
			} else if (isSquareList) {
				tabLists = d.getElementsByClassName(squareListClass);
				listType = "squarelist";
				ctaType = "squareHasCta"
			} else {
				tabLists = d.getElementsByClassName(tabListClass);
				listType = "tablist";
				ctaType = "tabHasCta"
			}
			
			i = tabLists.length;
			
			while (i--) {
				_initialiseTabList(tabLists[i], listType, ctaType);
			}
		}

		if (isSquareList || isToggleList) {
			activeSquareAndToggle();
		}

		if (isSquareList) {
			nextButton.on("click", goToNext);
			prevButton.on("click", goToPrevious);
		}
	};

	function goToNext() {
		current++;
		if (current < 1) {
			current = 1;
		}
		
		var nextElement = "li.squareHasCta#" + (current) + ' a';
		var nextSlide = "li.slider-bar" + (current);
		var slideMargin = ((current - 1) * perSlideScroll) + "px";

		document.querySelector("[aria-selected='true']").setAttribute("aria-selected", "false");
		$(nextElement).attr("aria-selected", "true");

		moveSlide(slideMargin, perSlideScroll, nextSlide);
		tabCount(current);
		goToSquare(current);
		changeContent(current);
		setQueryStringParameter("tabname", $(nextElement).attr("href").replace("#", ""));
	}

	function goToPrevious() {
		current--;
		
		let previousElement = "li.squareHasCta#" + (current) + ' a';
		let previousSlide = "li.slider-bar" + (current);
		let slideMargin = ((current - 1) * perSlideScroll) + "px";

		document.querySelector("[aria-selected='true']").setAttribute("aria-selected", "false");
		$(previousElement).attr("aria-selected", "true");

		moveSlide(slideMargin, perSlideScroll, previousSlide);
		goToSquare(current);
		changeContent(current);
		setQueryStringParameter("tabname", $(previousElement).attr("href").replace("#", ""));
	}

	function changeContent(current) {
		$(".tabs-container .overlay-section section").each(function (index, element) {
			element.setAttribute("role", "tabpanel");
			if (index === (current - 1)) {
				element.setAttribute("aria-hidden", false);
			} else {
				element.setAttribute("aria-hidden", true);
			}
		});
	}

	function moveSlide(slideMargin, perSlideScroll, slide) {
		$("li#slider-bar.active").removeClass("active");
		$(slide).addClass("active").css({ "margin-left": slideMargin, "width": perSlideScroll + "px" });
	}

	function goToSquare(activeIndex) {
		var offset = ((activeIndex - 1) * sha.outerWidth()) + ((activeIndex - 2) * 40);
		
		if (activeIndex === 1) {
			toggleBtn(prevButton, false);
		} else {
			toggleBtn(prevButton, true);
		}

		if (sha.length > activeIndex) {
			toggleBtn(nextButton, true);
		} else {
			toggleBtn(nextButton, false);
		}

		tabCount(activeIndex);

		document.querySelector(".squarelist").scrollLeft = offset;
	}

	function tabCount(activeIndex) {
		$(".square-count").text(squareTextCount.replace("$current", activeIndex));
	}

	function toggleBtn(btn, show) {
		if (show) {
			if (btn.hasClass("squarelist-prev") && $(".squarelist-prev").hasClass("button-color-change")) {
				$(".squarelist-prev").removeClass("button-color-change");
			}

			if (btn.hasClass("squarelist-next") && $(".squarelist-next").hasClass("button-color-change")) {
				$(".squarelist-next").removeClass("button-color-change");
			}
			btn.css({ "pointer-events": "all" });
		} else {
			if (btn.hasClass("squarelist-prev")) {
				$(".squarelist-prev").addClass("button-color-change");
			}

			if (btn.hasClass("squarelist-next")) {
				$(".squarelist-next").addClass("button-color-change");
			}
			btn.css({ "pointer-events": "none" });
		}
	}

	function activeSquareAndToggle() {
		flag = true;
		if (isSquareList) {
			current = Number(document.querySelector("[aria-selected='true']").getAttribute("squaretabid"));
			let nextSlide = "li.slider-bar" + (current);
			let slideMargin = ((current - 1) * perSlideScroll) + "px";
			let activeSquare = ".squarelist li.squareHasCta#" + current;
			let getSquareHrefId = $(activeSquare + " a").attr("href");
			squareTextCount = document.querySelector(".square-count").getAttribute("data-tab");
			squareTextCount = squareTextCount.replace("$number", sha.length);
			document.querySelector(".overlay-section [aria-hidden='false']").setAttribute("aria-hidden", "true");
			if (document.querySelector(".overlay-section " + getSquareHrefId)) {
				document.querySelector(".overlay-section " + getSquareHrefId).setAttribute("aria-hidden", "false");
			}
			moveSlide(slideMargin, perSlideScroll, nextSlide);
			goToSquare(current);

			document.querySelector(".slider-barlist #slider-bar").classList.add("active");
		} else {
			let toggleBoxActive = Number(document.querySelector("[aria-selected='true']").getAttribute("squaretabid"));
			let activeToggle = ".togglelist li.toggleHasCta#" + toggleBoxActive;
			let getToogleHrefId = $(activeToggle + " a").attr("href");
			$(activeToggle + " a .toggle-header").addClass("active");
			document.querySelector(".overlay-section [aria-hidden='false']").setAttribute("aria-hidden", "true");
			if (document.querySelector(".overlay-section " + getToogleHrefId)) {
				document.querySelector(".overlay-section " + getToogleHrefId).setAttribute("aria-hidden", "false");
			}
		}
	}

	return {
		init: init
	};

}());

accessibleTabs6.init({
	toggleListClass: "togglelist",   // default, may omit
	squareListClass: "squarelist",   // default, may omit
	tabListClass: "tablist",   // default, may omit
	onClass: "ON",               // default, may omit
	hoverableClass: "tl-hoverable"  // default, may omit
});

const handleTabFocusOverlay = () => {
	let isPageTabVisible = false;
	let isBottom = false;
	let isStuck = false;
	let stickyTarget;
	const target = document.querySelector('.tabs-container');

	if ($('div').hasClass('squarelist-container')) {
		stickyTarget = document.querySelector('ul.squarelist');
	} else if ($('div').hasClass('togglelist-container')) {
		stickyTarget = document.querySelector('ul.togglelist');
	} else {
		stickyTarget = document.querySelector('ul.tablist');
	}

	const toggleOverlays = () => {
		const shouldDisplayOverlay =
			isStuck && isPageTabVisible && !isBottom;

		if (shouldDisplayOverlay) {
			$('body').addClass('overlay-visible');
		} else {
			$('body').removeClass('overlay-visible');
		}
	}

	const isStickyObserver = new MutationObserver(([mutation]) => {
		isStuck = $(stickyTarget).hasClass('is-stuck');
		toggleOverlays();
	});

	const tabVisibilityObserver = new IntersectionObserver(([entry]) => {
		isPageTabVisible = entry.isIntersecting
		toggleOverlays();
	}, {
		threshold: [0]
	});

	if (target && stickyTarget) {
		document.addEventListener('scroll', function () {
			const documentHeight = document.body.scrollHeight;
			const currentScroll = window.scrollY + window.innerHeight;
			const offset = 100;
			let isBottomNew = currentScroll >= documentHeight - offset;

			if (isBottomNew !== isBottom) {
				isBottom = isBottomNew;
				toggleOverlays();
			}
		});

		isStickyObserver.observe(stickyTarget, {
			attributes: true
		});

		tabVisibilityObserver.observe(target);
	}
}

$(function () {
	handleTabFocusOverlay();

	//identify page tabs truncation width
	if (shvenergy.utils.isMobile()) {
		const tablistAnchors = document.querySelectorAll('.tablist > li > a');
		
		tablistAnchors.forEach(item => {
			const tabHeaderWidth = item.querySelector('.tab-header').clientWidth;

			if(tablistAnchors.length > 2){
				if(tabHeaderWidth > 100 && window.innerWidth < 420){
					item.querySelector('.tab-header').style.maxWidth = "5rem";
				}
				if(window.innerWidth > 420){
					item.querySelector('.tab-header').style.maxWidth = "8rem";
				}
			}
		});
	}

	if (document.querySelector('ul.tablist') || document.querySelector('ul.squarelist') || document.querySelector('.togglelist')) {
		let toTopEl = document.querySelector('#to-top');
		$.fn.isInViewport = function () {
			let extraTop = 45;
			if ($('div').hasClass('squarelist-container')) {
				extraTop = 170;
			}
			if ($('div').hasClass('togglelist-container')) {
				extraTop = 110;
			}

			const elementTop = $(this).offset().top;
			const elementBottom = elementTop + $(this).outerHeight();
			
			const viewportTop = $(window).scrollTop() + extraTop;
			const viewportBottom = viewportTop + $(window).height();
			
			return elementBottom > viewportTop && elementTop < viewportBottom;
		};

		$(window).on('resize scroll', function () {
			let header = window.matchMedia("(min-width: 1200px)").matches ? $(".main-menu-border").outerHeight() + $(".service-menu-border").outerHeight() : $(".mobile-header").outerHeight();
			let listHasStuck, toTopHeight;
			let isTabInViewPort = $('.tabs-container').isInViewport();
			if ($('.togglelist').length > 0) {
				listHasStuck = $('.togglelist').hasClass('is-stuck');
				toTopHeight = document.querySelector('ul.togglelist').offsetHeight;
			} else if ($('.squarelist').length > 0) {
				listHasStuck = $('.squarelist').hasClass('is-stuck');
				toTopHeight = document.querySelector('.slider-with-arrow').offsetHeight + (window.matchMedia("(min-width: 1200px)").matches ? -12 : 35);
			} else {
				listHasStuck = $('.tablist').hasClass('is-stuck');
				toTopHeight = document.querySelector('ul.tablist').offsetHeight;
			}
			
			if (listHasStuck && isTabInViewPort) {
				toTopEl ? toTopEl.style.top = toTopHeight + header + "px" : "";
			}

			if (!listHasStuck || !isTabInViewPort) {
				toTopEl ? toTopEl.style.top = header + "px" : "";
			}

			if ($('div').hasClass('tablist-container') && !isTabInViewPort && listHasStuck) {
				$('ul.tablist').css({ "opacity": "0", "top": "-100%" });
			}

			if ($('div').hasClass('tablist-container') && isTabInViewPort) {
				$('ul.tablist').css({ "opacity": "1", "top": "0" });
			}

			if ($('div').hasClass('squarelist-container') && !isTabInViewPort && listHasStuck) {
				$('ul.squarelist').css({ "opacity": "0", "top": "-100%" });
				$('.slider-with-arrow').css({ "opacity": "0", "top": "-100%" });
			}

			if ($('div').hasClass('squarelist-container') && isTabInViewPort) {
				if (listHasStuck) {
					$('.tabs-container .overlay-section').css({ "top": "35px" });
				} else {
					$('.tabs-container .overlay-section').css({ "top": "0" });
				}

				$('ul.squarelist').css({ "opacity": "1", "top": "0" });
				$('.slider-with-arrow').css({ "opacity": "1", "top": "0" });
			}

			if ($('div').hasClass('togglelist-container') && !isTabInViewPort && listHasStuck) {
				$('.togglelist').css({ "opacity": "0", "top": "-100%" });
			}

			if ($('div').hasClass('togglelist-container') && isTabInViewPort) {
				$('.togglelist').css({ "opacity": "1", "top": "0" });
			}
		});
	}
});
